import { BaseMediaApiModel } from '@rocksoft/inroom-sdk';

import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

import { TvChannelsActionsUnion, TvChannelsActionTypes } from './tv-channels.actions';

export const inRoomTvChannelsFeatureKey = 'inroom-tv-channels';

export type TvChannelsState = EntityState<BaseMediaApiModel>;

export function selecTvChannelId(tvChannel: BaseMediaApiModel): string {
  return tvChannel.Identifier ?? '';
}

export const adapter: EntityAdapter<BaseMediaApiModel> = createEntityAdapter<BaseMediaApiModel>({
  selectId: selecTvChannelId,
});

export const initialState: TvChannelsState = adapter.getInitialState({});

export function tvChannelReducer(
  state: TvChannelsState = initialState,
  action: TvChannelsActionsUnion
): TvChannelsState {
  switch (action.type) {
    case TvChannelsActionTypes.LOAD_TV_CHANNELS:
      return adapter.setAll(action.payload, state);
    default:
      return state;
  }
}

const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();

export const selectTvChannelIds = selectIds;

export const selectTvChannelEntities = selectEntities;

export const selectAllTvChannels = selectAll;

export const selectTvChannelsTotal = selectTotal;
